module.exports = __webpack_public_path__ + "img/data_bottom.2bfb2e3f.gif";